import { BOARD_TYPE, ImasterSet } from '../../src/typings/boardType';

export const masterHomeSet = {
  typeName: BOARD_TYPE.HOME,
  path: 'home',
};
export const masterSet: ImasterSet = {
  boardSet: [
    { typeName: BOARD_TYPE.POSTING, path: 'posting' },
    { typeName: BOARD_TYPE.POSTING, path: 'posting2' },
    { typeName: BOARD_TYPE.MEMO, path: 'memo' },
    { typeName: BOARD_TYPE.CALENDAR, path: 'calendar' },
    { typeName: BOARD_TYPE.PHOTOCARD, path: 'photocard' },
    { typeName: BOARD_TYPE.STICKERBOARD, path: 'stickerBoard' },
    { typeName: BOARD_TYPE.WORLD, path: 'world' },
    { typeName: BOARD_TYPE.HISTORY, path: 'history' },
    { typeName: BOARD_TYPE.TIMELINE, path: 'timeline' },
    { typeName: BOARD_TYPE.COUPLE, path: 'couple' },
    { typeName: BOARD_TYPE.GUESTBOOK, path: 'guestbook' },
    { typeName: BOARD_TYPE.STORE, path: 'store' },
    { typeName: BOARD_TYPE.CALCULATE, path: 'calculate' },
    { typeName: BOARD_TYPE.FORM, path: 'form' },
    { typeName: BOARD_TYPE.WORLDMAP, path: 'worldmap' },
    { typeName: BOARD_TYPE.QUEST, path: 'quest' },
  ],
  cursorCustom: true,
  backgroundEffect: true,
  commentMode: {
    battle: true,
  },
  widget: {
    ddayWidget: true,
    currentBoardWidget: false,
  },
  postingThemeSet: true,
  photocardPosting: true,
  challenge: false,
  soundEffect: true,
  photocardThemeSet: true,
  stickerDoc: true,
  gatePage: true,
  shootingStar: false,
  themeManager: true,
  calendarSticker: true,
  chat: true,
  simeji: false,
  status: true,
  photocardHistory: false,
  petSystem: false,
  explorationSystem: true,
};
